import React, { useState } from "react";
import { Box, Button, Typography, TextField, FormControl, FormLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { toast } from 'sonner';
import CloseIcon from '@mui/icons-material/Close';
import { Editor } from "@monaco-editor/react";
import { Add, Delete } from "@mui/icons-material";
import FlashOnIcon from '@mui/icons-material/FlashOn';
import Condition from "./tool/ToolCondition";
import SearchBrowseForm from "./tool/searchAndBrowse";
import FloorplanAnalysisForm from "./tool/floorPlan";
import DocParsingForm from "./tool/DocParsing";
import ImageAnalysisForm from "./tool/imageAnalysis";
import TextToNeo4jForm from "./tool/TextToNeo4j";
import GraphQueryForm from "./tool/graphQuery";
import ReportingForm from "./tool/Reporting";



const Tools = [
  { id: 1, ToolName: "Email Send" },
  { id: 2, ToolName: "Condition" },
  { id: 3, ToolName: "Api call" },
  { id: 4, ToolName: "Add Data to Another collection" },
  { id: 5, ToolName: "Text to JSON" },
  { id: 6, ToolName: "Search & Browse" },
  { id: 7, ToolName: "Doc Parsing" },
  { id: 8, ToolName: "Floorplan Analysis" },
  { id: 9, ToolName: "Image Analysis" },
  { id: 10, ToolName: "Text to Neo4j" },
  { id: 11, ToolName: "Graph Query" },
  { id: 12, ToolName: "Reporting" },





];

const conditionOptions = [
  { label: "is equal to", value: "===" },
  { label: "is not equal to", value: "!==" },
  { label: "is greater than", value: ">" },
  { label: "is less than", value: "<" },
  { label: "is greater than or equal to", value: ">=" },
  { label: "is less than or equal to", value: "<=" },
];

const AddWorkflow = () => {
  const navigate = useNavigate();
  const [workflowName, setWorkflowName] = useState("");
  const [selectedTool, setSelectedTool] = useState(null);
  const [triggerOpen, setTriggerOpen] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [toolDetails, setToolDetails] = useState({});

  const handleToolClick = (tool) => {
    setSelectedTool(tool);
    setDialogOpen(true);
  };


  
  const handleTaskClick = () => {
    if (!selectedTool) {
      toast.warning("Please select the tool to add the task");
    }
  };

  const handleTriggerClick = () => {
    setTriggerOpen(!triggerOpen);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setToolDetails({});
  };

  const handleRemoveTask = (index) => {
    const updatedTasks = [...taskList];
    updatedTasks.splice(index, 1);
    setTaskList(updatedTasks);
  };

  const handleAddTool = () => {
    const isAlreadyAdded = taskList.some(task => task.tool === selectedTool.ToolName);
    if (isAlreadyAdded) {
      toast.warning(`${selectedTool.ToolName} already added to the task`);
      return;
    }
  
    setTaskList([...taskList, { tool: selectedTool.ToolName, details: toolDetails }]);
    setDialogOpen(false);
    setToolDetails({});
    setSelectedTool(null);
  };
  
  const collection=['User', 'Lead'];
    const action=['update', 'Delete'];
    const method=['GET,PUT'];


    const [conditions, setConditions] = useState([{ value1: "", operator: "===", value2: "" }]);

    const handleAddCondition = () => {
      setConditions([...conditions, { value1: "", operator: "===", value2: "" }]);
    };
  
    const handleDeleteCondition = (index) => {
      setConditions(conditions.filter((_, i) => i !== index));
    };
  
    const handleChange = (index, field, value) => {
      const newConditions = [...conditions];
      newConditions[index][field] = value;
      setConditions(newConditions);
    };

    const [inputFormData, setInputFormData] = useState({
      raw_text: "",
      schema_definition: "",
      output_format: "JSON",
    });
  
    const outputOptions = ["JSON", "XML", "YAML"];

  const renderToolForm = () => {
    

    const configurations = ['sample', 'smtp', 'api'];
    
    switch (selectedTool?.ToolName) {
      case "Email Send":
        return (
                    <>
                      <Grid item size={12}>
                        <FormControl fullWidth>
                          <FormLabel>Select Configuration</FormLabel>
                          <TextField
                            select
                            value={toolDetails.configuration}
                            onChange={(e) => setToolDetails({ ...toolDetails, configuration: e.target.value })}
                          >
                            {configurations.map((config, index) => (
                              <MenuItem key={index} value={config}>
                                {config}
                              </MenuItem>
                            ))}
                          </TextField>
                        </FormControl>
                      </Grid>
                      <Grid item size={12}>
                        <FormControl fullWidth>
                          <FormLabel sx={{marginY:1}}>Recipient Email</FormLabel>
                          <TextField
                            value={toolDetails.recipientEmail || ""}
                            onChange={(e) => setToolDetails({ ...toolDetails, recipientEmail: e.target.value })}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item size={12}>
                        <FormControl fullWidth>
                          <FormLabel sx={{marginY:1}}>Subject</FormLabel>
                          <TextField
                            value={toolDetails.subject || ""}
                            onChange={(e) => setToolDetails({ ...toolDetails, subject: e.target.value })}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item size={12}>
                        <FormControl fullWidth>
                          <FormLabel sx={{marginY:1}}>Body</FormLabel>
                          <TextField
                            multiline
                            value={toolDetails.body || ""}
                            onChange={(e) => setToolDetails({ ...toolDetails, body: e.target.value })}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item size={12}>
                      <FormControl fullWidth>
  <FormLabel sx={{marginY:1}}>HTML Content</FormLabel>
 
         <Editor
                height="150px"
                options={{
                  minimap: { enabled: false },
                  scrollbar: { vertical: "hidden" },
                  automaticLayout: true,
                }}
                value={toolDetails.htmlContent || ""}
    onChange={(e) => setToolDetails({ ...toolDetails, htmlContent: e.target.value })}
              />
</FormControl>

                      </Grid>
                    </>
        );
      case "Condition":
        return (
          <Box sx={{ p: 3, border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
      {conditions.map((condition, index) => (
        <Condition
          key={index}
          index={index}
          condition={condition}
          onDelete={handleDeleteCondition}
          onChange={handleChange}
          showOperator={index !== 0}
        />
      ))}
      <Button  sx={{ p: 2, border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#f9f9f9" }} startIcon={<Add />} onClick={handleAddCondition} fullWidth>
        Add Condition
      </Button>
    </Box>
        );
      case "Api call":
        return (
          <>
           <Grid item size={12}>
                        <FormControl fullWidth>
                          <FormLabel sx={{marginY:1}}>ApiUrl</FormLabel>
                          <TextField
                          />
                        </FormControl>
                      </Grid>
            <Grid size={12}>
            <FormControl fullWidth>
              <FormLabel>Method</FormLabel>
              <TextField
                select
                placeholder="Choose Collection"
                required
              >
               {method.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
          <Grid size={12}>
            <FormControl fullWidth>
              <FormLabel>Header</FormLabel>
              <Editor
                height="150px"
                defaultLanguage="json"
                options={{
                  minimap: { enabled: false },
                  scrollbar: { vertical: "hidden" },
                  automaticLayout: true,
                }}
              />

              
            </FormControl>
          </Grid>


          <Grid size={12}>
            <FormControl fullWidth>
              <FormLabel>Body</FormLabel>
              <Editor
                height="150px"
                defaultLanguage="json"
                options={{
                  minimap: { enabled: false },
                  scrollbar: { vertical: "hidden" },
                  automaticLayout: true,
                }}
              />

              
            </FormControl>
          </Grid>
          </>
        );

        case "Add Data to Another collection":
          return(
            <>
            <Grid size={12}>
            <FormControl fullWidth>
              <FormLabel>Choose Collection</FormLabel>
              <TextField
                select
                placeholder="Choose Collection"
                required
              >
               {collection.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
          <Grid size={12}>
            <FormControl fullWidth>
              <FormLabel>Data</FormLabel>
              <Editor
                height="200px"
                defaultLanguage="json"
                options={{
                  minimap: { enabled: false },
                  scrollbar: { vertical: "hidden" },
                  automaticLayout: true,
                }}
              />
            </FormControl>
          </Grid>
          </>
          );
          case "Text to JSON":
            return(
              <form >
                <Grid size={12}>
                  <FormControl fullWidth>
                    <FormLabel>Raw Text Input</FormLabel>
                    <TextField
                      name="raw_text"
                      multiline
                      value={inputFormData.raw_text}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
        
                <Grid size={12}>
                  <FormControl fullWidth>
                    <FormLabel>JSON Schema for Output</FormLabel>
                    <Editor
                     height="200px"
                     defaultLanguage="json"
                      name="schema_definition"
                      multiline
                      value={inputFormData.schema_definition}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
        
                <Grid size={12}>
                  <FormControl fullWidth>
                    <FormLabel>Output Format</FormLabel>
                    <TextField
                      name="output_format"
                      select
                      value={inputFormData.output_format}
                      onChange={handleChange}
                    >
                      {outputOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>
                </form>

            )

            case  "Search & Browse":
              return(
                <SearchBrowseForm />
              )
              case "Doc Parsing":
                return(
                  <DocParsingForm />
                )

              case "Floorplan Analysis":
                return(
                  <FloorplanAnalysisForm />
                )

                case  "Image Analysis":
                  return(
                    <ImageAnalysisForm />
                  )

                  case  "Text to Neo4j":
                    return(
                      <TextToNeo4jForm />
                    )

                    case  "Graph Query":
                      return(
                        <GraphQueryForm />
                      )

                      case  "Reporting":
                      return(
                        <ReportingForm />
                      )
      default:
        return null;
    }
  };

//   const Condition = ({ index, condition, onDelete, onChange,showOperator }) => {
//     return (
//       <>
//       {showOperator && (
//         <Grid marginBottom={3} sx={{ display: "flex", alignItems: "center" }}>
//           <TextField
//             select
//             size="medium"
//             value={condition.logicOperator || ""}
//             onChange={(e) => onChange(index, "logicOperator", e.target.value)}
//             sx={{ marginRight: 2, width: "150px" }}
//           >
//             <MenuItem value="AND">AND</MenuItem>
//             <MenuItem value="OR">OR</MenuItem>
//           </TextField>
//         </Grid>
//       )}
//       <Grid sx={{display:"flex"}} marginBottom={3}>
//     <TextField
//     placeholder="value 1"
//       size="medium"
//       value={condition.value1}
//       onChange={(e) => onChange(index, "value1", e.target.value)}
//     />
//     <TextField
//       select
//       size="medium"
//       value={condition.operator}
//       onChange={(e) => onChange(index, "operator", e.target.value)}
//     >
//       {conditionOptions.map((option) => (
//         <MenuItem key={option.value} value={option.value}>
//           {option.label}
//         </MenuItem>
//       ))}
//     </TextField>
//     <TextField
//       placeholder="Value 2"
//       size="medium"
//       value={condition.value2}
//       onChange={(e) => onChange(index, "value2", e.target.value)}
//     />
//     <IconButton onClick={() => onDelete(index)} color="error" sx={{border:"none"}}>
//     <CloseIcon />
//     </IconButton>
// </Grid>
// </>

//     );
//   };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center" sx={{ mb: 4 }}>
        Workflow Creation 
      </Typography>

      <Grid container spacing={4}>
        <Grid item size={8} md={6}>
          <FormControl fullWidth>
            <FormLabel>Workflow Name</FormLabel>
            <TextField
              sx={{width:"40%"}}
              placeholder="Enter the name"
              value={workflowName}
              onChange={(e) => setWorkflowName(e.target.value)}
            />
          </FormControl>

          <Box sx={{ display: 'flex', flexDirection: 'column', mt: 5}}>
          <Box
  sx={{ width: '30%', p: 1, border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center', cursor: 'pointer', mb: 2, height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}
  onClick={handleTriggerClick}
>
  <FlashOnIcon  />
  Select Trigger
</Box>

            {triggerOpen && (
            <Box sx={{ width: '50%', p: 2, border: '1px solid #ccc', borderRadius: '8px', mb: 4 }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel>Select Collection</FormLabel>
              <Select>
                            {collection.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
              </Select>
              </FormControl>
          
            <FormControl fullWidth>
              <FormLabel>Select Action</FormLabel>
              <Select>
              {action.map((action, index) => (
                  <MenuItem key={index} value={action}>{action}</MenuItem>
                ))}
                </Select>
              
            </FormControl>
          </Box>
          
            )}

           
          </Box>
         
          <Box sx={{ width: '80%', p: 2, border: '1px solid #ccc', borderRadius: '8px', mt: 4 }}>
            <Box sx={{display:"flex",justifyContent:"space-between"}}>
  <Typography variant="h6" sx={{ mb: 2 }}>Tasks</Typography>
  <Box
              sx={{ width: '20%', p: 1, border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center', cursor: 'pointer', mb: 2, height: "30px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              onClick={handleTaskClick}
            >
              Add Tasks
            </Box>
  </Box>
  {taskList.map((task, index) => (
    <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1, mb: 1, backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
      <Typography>{task.tool}</Typography>
      <IconButton color="error" onClick={() => handleRemoveTask(index)} sx={{border:"none"}}>
        <CloseIcon />
      </IconButton>
    </Box>
  ))}
  
</Box>





        
        </Grid>

        <Grid item size={4} md={4}>
          <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '8px',height:"450px",overflowY:"auto" }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Tools</Typography>
            {Tools.map((tool) => (
              <Button
                key={tool.id}
                fullWidth
                sx={{ mb: 1, border: '1px solid #ccc', borderRadius: '8px' }}
                onClick={() => handleToolClick(tool)}
              >
                {tool.ToolName}
              </Button>
            ))}
          </Box>
        </Grid>
        
      </Grid>

      <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth>
        <DialogTitle>{selectedTool?.ToolName}</DialogTitle>
        <DialogContent sx={{maxWidth:"900px"}}>
          {renderToolForm()}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleAddTool} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
      <Box
  sx={{
  
    position: "absolute",  
    bottom: 30,       
    right: 40,        
    zIndex: 999       }}
>
  <Button variant="contained" sx={{ color: "success" }}>Save Workflow</Button>
</Box>



    </Box>
  );
};

export default AddWorkflow;